"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const createFlow = (flow) => {
    const missingNeeds = flow.missingNeeds || {};
    const needs = flow.needs || {};
    const nodes = flow.nodes || {};
    const taskState = flow.taskState || {};
    const extraNeeds = flow.extraNeeds || {};
    flow = lodash_1.default.extend({
        isLoaded: true,
        pages: {},
        errors: [],
        sampleStates: {},
        staleSamples: {},
        dirtyTaskState: {},
        dirtyNeeds: {},
        needsMeta: {},
        nodeLoading: {},
        nodeUpdateStamps: {},
        givesAll: {},
        openStepMenus: {},
        lastTestStatuses: {},
        removalStatus: 'initial',
        openAddStepPickerNodeId: null,
        isAddingOrRemovingStep: false,
    }, flow, {
        nodes,
        needs,
        missingNeeds,
        taskState,
        extraNeeds,
    });
    return flow;
};
exports.default = createFlow;
